'use strict'

Object.defineProperty(exports, '__esModule', {
  value: true
})
exports.register = undefined

var _typeof = typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol' ? function (obj) { return typeof obj } : function (obj) { return obj && typeof Symbol === 'function' && obj.constructor === Symbol && obj !== Symbol.prototype ? 'symbol' : typeof obj } // @ts-check

var _vueEBus = require('vue-e-bus')

var _vueEBus2 = _interopRequireDefault(_vueEBus)

var _vue = require('vue')

var _vue2 = _interopRequireDefault(_vue)

function _interopRequireDefault (obj) { return obj && obj.__esModule ? obj : { default: obj } }

var currentGlobal = null
/** @type {Array} */
var _with2 = null

/**
 * The spelling AppTranslationsController stores a key under: whitespace collapsed and full stops
 * removed. A key written with punctuation in the source therefore never matches the row the server
 * sends back, and has to be looked up in this form as well.
 *
 * @param {String} path
 * @return {String}
 */
function storedKey (path) {
  return String(path).replace(/\s+/g, ' ').replace(/^\s+/, '').split('.').join('')
}
/**
 * Register all plugin actions
 *
 * @param {String} initial initial language
 * @param {Array} languages array with languages
 * @param {Boolean} save if save language in local storage
 * @param {Function} middleware function for handler get
 */
var register = exports.register = function register (initial, languages, save, middleware) {
  if (save) {
    var lang = window.localStorage.getItem('vueml-lang')
    if (lang === null) {
      window.localStorage.setItem('vueml-lang', initial)
    }
    else {
      initial = lang
    }
  }

  if (initial === null) {
    return console.error('[vue-multilanguage] initial language is null, please set a value')
  }
  currentGlobal = initial
  return {
    /**
     * Called before create component
     */
    beforeCreate: function beforeCreate () {
      var _this = this

      var self = this

      this.$ml = {
        /**
         * Change current language
         * @param {string} param new language
         */
        change: function change (param) {
          var current = languages.filter(function (l) {
            return l.name === param
          })
          if (current.length === 0) {
            return console.error('[vue-multilanguage] \'' + param + '\' language not found')
          }

          if (currentGlobal !== param) {
            if (save) {
              window.localStorage.setItem('vueml-lang', param)
            }
            _vueEBus2.default.$emit('vueml-language-changed', param)
          }
        },
        with: function _with (name) {
          var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false

          if (value !== false) {
            if (_with2 === null) {
              _with2 = []
            }
            _with2.push({ name: name, value: value })
          }
          else {
            _with2 = [name]
          }
          return this
        },
        get: function get (path) {
          var current = languages.filter(function (l) {
            return l.name === currentGlobal
          })
          if (current.length > 1) {
            return console.error('[vue-multilanguage] you define \'' + currentGlobal + '\' language two or more times')
          }
          var db = current[0].database

          if ('ml' + path in self) {
            path = 'ml' + path
            _with2 = self[path]._with
            path = self[path].path
          }

          path = middleware(self, path)

          if (!path) return ''

          // The dictionary is flat. The local file writes whole sentences as property names, and the
          // server strips full stops from every key it stores, so a sentence key is reachable only as
          // a property - never as a path. Walking it segment by segment would look for nesting that
          // cannot exist, which is why a direct hit is tried first, in both spellings.
          var direct = db[path]

          if (direct === undefined) {
            direct = db[storedKey(path)]
          }

          if (typeof direct === 'string') {
            db = direct
          }
          else {
            /** @type {Array} */
            var splitedPath = path.split('.')

            splitedPath.forEach(function (ph) {
              // A forEach cannot be broken out of, so once a segment is missing this keeps running
              // with db already false. Guarding here rather than returning from the callback is what
              // stops the next iteration evaluating `ph in false` and throwing - which is what any
              // key ending in a full stop does, its last segment being empty.
              if (db && typeof db === 'object' && ph in db) {
                db = db[ph]
              }
              else {
                db = false
              }
            })
          }

          if (db !== false) {
            if (Array.isArray(_with2)) {
              _with2.forEach(function (w) {
                if ((typeof w === 'undefined' ? 'undefined' : _typeof(w)) !== 'object') {
                  db = db.replace(/\{0\}/g, _with2[0])
                }
                else {
                  var replace = '{' + w.name + '}'
                  while (db.includes(replace)) {
                    db = db.replace(replace, w.value)
                  }
                }
              })
            }
            _with2 = null
            return db
          }
        },

        /**
         * get current permission
         */
        get current () {
          return currentGlobal
        },

        /**
         * get languages list
         */
        get list () {
          return languages.map(function (l) {
            return l.name
          })
        },

        /**
         * get languages database list
         */
        get db () {
          return languages.map(function (l) {
            return l.database
          })
        }
      }

      _vueEBus2.default.$on('vueml-language-changed', function (newLanguage) {
        currentGlobal = newLanguage
        _this.$forceUpdate()
      })
    }
  }
}
